import { text_mod_42, } from "../text/Text.js";
export const module42 = {
  title:
    "Літера ю маленька",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_42,
    },
  ]
};